import { render, staticRenderFns } from "./card-typing.vue?vue&type=template&id=1be6e46b&scoped=true&"
import script from "./card-typing.vue?vue&type=script&lang=js&"
export * from "./card-typing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be6e46b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/botter-dashbaord/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VSlider})
